export type {
  ExtractPageResult,
  GetBlockPointer,
  ICCPointer,
  IsDataAvailPointer,
  PageNumber,
  PageResult,
  PdfReaderPointer,
  PlotColor,
  PlotMediaEntry,
  PlotPageEntry,
  PlotShape,
  PlotShapeMedia,
  PlotShapePath,
  PlotShapeRect,
  PlotShapeText,
} from "../types/Types"
export { Functions } from "../generated/Encoders"

import type { ProvisionAPI } from "@pdfking/wasm-core"
import type { Functions } from "../generated/Encoders"
export type PdfiumAPI = ProvisionAPI<typeof Functions>
